var render, staticRenderFns
import script from "./lemon-message-wink.vue?vue&type=script&lang=js"
export * from "./lemon-message-wink.vue?vue&type=script&lang=js"
import style0 from "./lemon-message-wink.vue?vue&type=style&index=0&id=ac09f07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac09f07e",
  null
  
)

export default component.exports